import { getToken, resetState } from "../utils/index";

export default {
  namespaced: true,
  state: {
    error: null,
    initialLoad: true,
    refresh: false,
    topPinpad: {
      busy: false,
      data: [],
    },
    topPos: {
      busy: false,
      data: [],
    },
    topTransfer: {
      busy: false,
      data: [],
    },
    topAccount: {
      busy: false,
      data: [],
    },
  },
  mutations: {
    GET_TOP_PINPAD_START: (state) => {
      state.topPinpad.busy = true;
    },
    GET_TOP_PINPAD_FAILED: (state, error) => {
      state.topPinpad.busy = false;
      state.refresh = false;
      state.error = error;
    },
    GET_TOP_PINPAD_SUCCESS: (state, topPinpad) => {
      state.topPinpad.busy = false;
      state.refresh = false;
      state.topPinpad = topPinpad;
      console.log(topPinpad);
    },
    GET_TOP_POS_START: (state) => {
      state.topPos.busy = true;
    },
    GET_TOP_POS_FAILED: (state, error) => {
      state.topPos.busy = false;
      state.refresh = false;
      state.error = error;
    },
    GET_TOP_POS_SUCCESS: (state, topPos) => {
      state.topPos.busy = false;
      state.initialLoad = false;
      state.refresh = false;
      state.topPos = topPos;
      console.log(topPos);
    },
    GET_TOP_TRANSFER_START: (state) => {
      state.topTransfer.busy = true;
    },
    GET_TOP_TRANSFER_FAILED: (state, error) => {
      state.topTransfer.busy = false;
      state.refresh = false;
      state.error = error;
    },
    GET_TOP_TRANSFER_SUCCESS: (state, topTransfer) => {
      state.topTransfer.busy = false;
      state.refresh = false;
      state.topTransfer = topTransfer;
      console.log(topTransfer);
    },
    GET_TOP_ACCOUNT_START: (state) => {
      state.topAccount.busy = true;
    },
    GET_TOP_ACCOUNT_FAILED: (state, error) => {
      state.topAccount.busy = false;
      state.refresh = false;
      state.error = error;
    },
    GET_TOP_ACCOUNT_SUCCESS: (state, topAccount) => {
      state.topAccount.busy = false;
      state.refresh = false;
      state.topAccount = topAccount;
      console.log(topAccount);
    },
    REFRESH: (state) => {
      state.refresh = true;
    },
  },
  actions: {
    async getTopPinpad({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_TOP_PINPAD_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/agents/top?start=${payload.startDate}&end=${payload.endDate}&type=pinpad`,
          config
        );
        const data = await response.json();
        commit("GET_TOP_PINPAD_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_TOP_PINPAD_FAILED", err);
      }
    },
    async getTopPos({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_TOP_POS_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/agents/top?start=${payload.startDate}&end=${payload.endDate}&type=pos`,
          config
        );
        const data = await response.json();
        commit("GET_TOP_POS_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_TOP_POS_FAILED", err);
      }
    },
    async getTopTransfer({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_TOP_TRANSFER_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/agents/top?start=${payload.startDate}&end=${payload.endDate}&type=transfer`,
          config
        );
        const data = await response.json();
        commit("GET_TOP_TRANSFER_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_TOP_TRANSFER_FAILED", err);
      }
    },
    async getTopAccount({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_TOP_ACCOUNT_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/agents/top?start=${payload.startDate}&end=${payload.endDate}&type=account`,
          config
        );
        const data = await response.json();
        commit("GET_TOP_ACCOUNT_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_TOP_ACCOUNT_FAILED", err);
      }
    },
    async refresh({ commit }) {
      commit("REFRESH");
    },
  },
};
